/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AgentPluginServer = {
  /**
   * Link to the server's page in the Speakeasy dashboard. Present only when the enrolled user holds mcp:read on the server; the agent tells the user that links need that scope when it is absent.
   */
  dashboardUrl?: string | undefined;
  /**
   * Display name of the server within its plugin.
   */
  name: string;
};

/** @internal */
export const AgentPluginServer$inboundSchema: z.ZodMiniType<
  AgentPluginServer,
  unknown
> = z.pipe(
  z.object({
    dashboard_url: z.optional(z.string()),
    name: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "dashboard_url": "dashboardUrl",
    });
  }),
);

export function agentPluginServerFromJSON(
  jsonString: string,
): SafeParseResult<AgentPluginServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentPluginServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentPluginServer' from JSON`,
  );
}
